import React from 'react';
import { UserRecord } from '../model/types';

export interface UserDataContextType {
  userRecord: UserRecord | null;
  isLoading: boolean;
  error: string | null;
  clearError: () => void;
}

export const UserDataContext = React.createContext<UserDataContextType>({
  userRecord: null,
  isLoading: false,
  error: null,
  clearError: () => {},
});
